import type { AnyPresentationOption, OptionsDocument } from 'paintscout'
import {
  getPresentationNextOptions,
  getPresentationOptions
} from '../../../options/presentation/get-presentation-options'
import { findPresentationOption } from '../find-presentation-option'
import type { QuoteTypeOption } from '../../../options'

export function getInitialPresentation(args?: {
  options: OptionsDocument
  quoteType: QuoteTypeOption
}): AnyPresentationOption {
  const { options, quoteType } = args
  const presentationOptions = getPresentationOptions({ options })
  const presentationOptionsV2 = getPresentationNextOptions({ options })

  const defaultPresentation = presentationOptions[0]

  // If quoteType has a default presentation attached use it, else
  if (quoteType?.defaultPresentation) {
    const p = findPresentationOption({
      key: quoteType.defaultPresentation,
      v1: presentationOptions,
      v2: presentationOptionsV2
    })
    if (p) {
      return p
    }
  }

  // if user has a general default presentation, else use the first presentation(default)
  if (options.options.defaultPresentation) {
    const p = findPresentationOption({
      key: options.options.defaultPresentation,
      v1: presentationOptions,
      v2: presentationOptionsV2
    })
    if (p) {
      return p
    }
  }

  return defaultPresentation
}
